<div class="callout">
  <div class="message-container">
    <div class="image-container">
      <img src="../../../../../assets/images/alarm.svg" alt="Alarm" />
    </div>
    <div class="text-container">
      <h1>You're Almost There</h1>
      <p>
        Your commission, certification, or signature needs a quick update before we can continue. Update now or reschedule your signing for later.
      </p>
      <div class="button-container">
        <app-button
          type="warning-secondary"
          (buttonClick)="cancelSigning()"
          [dataTestId]="'expired-commission-cancel-signing'"
        >
          Cancel Signing
        </app-button>
        <app-button
          type="primary"
          (buttonClick)="updateCommission()"
          [dataTestId]="'expired-commission-update'"
          >
          Update Credentials
        </app-button>
      </div>
    </div>
  </div>
</div>
